import ApiClient from "../api/apiClient";

const BULK_CPD_UPLOAD = "/bulk-registration/bulk-cpd-upload";
const BULK_CPD = "/bulk-registration/bulk-cpd-upload";
const ORGANIZATION_CSV_UPLOAD = "/bulk-registration/csv";

const uploadBulkCpd = (data) => {
    return ApiClient.post(BULK_CPD_UPLOAD, data);
};

const uploadBulkOrganization = (data) => {
    return ApiClient.post(ORGANIZATION_CSV_UPLOAD, data);
};
const getBulkCpd = ({ page, limit }) => {
    const baseUrl = `${BULK_CPD}?`;
    let queryParams = "";
    // Add mandatory parameters
    queryParams += `page=${page}&limit=${limit}`;
    const url = baseUrl + queryParams;
    return ApiClient.get(url);
};

export const bulkRegistrationService = {
    uploadBulkCpd,
    getBulkCpd,
    uploadBulkOrganization,
};
